import { useState, useEffect } from "react";
import { Box, Paper } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close"
import { MenuSelect } from 'components/Select/menuSelect';
import { OutlineRectangleButton } from 'components/buttons/OutlineRectangleButton';
import { ReactComponent as DeleteIcon } from "assets/images/icons/icn_table_cell_Unverified.svg";

const TimeChipSelector = ({
  timeList = [],
  max = Infinity,
  onAddTimeChip,
  onDeleteTimeChip,
}) => {
  const [selected, setSelected] = useState(timeList[0] ?? null);
  const [items, setItems] = useState(
    () => timeList.filter((o) => o.isSelected)
  );

  const onAdd = () => {
    if (!selected) return;

    if (items.length >= max) return;
    if (items.find((i) => i.value === selected.value)) return;

    const next = [...items, selected];
    setItems(next);
    onAddTimeChip?.(selected.value);
  };

  const onDelete = (item) => {
    setItems((prev) => prev.filter((i) => i.value !== item.value));
    onDeleteTimeChip?.(item.value);
  };

  useEffect(() => {
    setItems(timeList.filter(time => time.isSelected));
  }, [timeList]);

  return (
    <Box>
      <Box sx={{ display: "flex", mb: 1.5, alignItems: "center" }}>
        <MenuSelect
          value={selected?.value}
          onChange={(opt) => setSelected(opt)}
          options={timeList}
          width={130}
        />
        <OutlineRectangleButton
          iconStart={<AddCircleOutlineIcon />}
          width={80}
          height={29}
          disabled={items.length >= max}
          onClick={onAdd}
        >
          Add
        </OutlineRectangleButton>
      </Box>

      <Paper
        sx={{
          minHeight: 56,
          mt: -1,
          p: 1.5,
          display: "grid",
          gridTemplateColumns: "repeat(5, auto)",
          justifyContent: "start",
          gap: 1,
          alignContent: "flex-start",
          borderRadius: 2,
          boxShadow: "0px 1px 4px rgba(0,0,0,0.08)",
          border: "none",
        }}
      >
        {items.map((item) => (
          <Box
            key={item.value}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.2,
              color: "#172664",
              fontWeight: "600",
              fontSize: 13,
              lineHeight: 1,
            }}
          >
            {item.label}
            <Box
              onClick={() => onDelete(item)}
              sx={{ cursor: "pointer" }}
            >
              <DeleteIcon />
            </Box>

          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default TimeChipSelector;